import { baseApi } from './baseApi';
import type { CreditConfig, CreditPackage } from '@nimbazaar/types';
import { API_ENDPOINTS } from '@nimbazaar/constants';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

interface LegalPage {
  slug: string;
  title: string;
  content: string;
  updatedAt: string;
}

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditConfig: builder.query<ApiResponse<CreditConfig>, void>({
      query: () => API_ENDPOINTS.SETTINGS.CREDITS,
      providesTags: ['CreditConfig'],
    }),
    getCreditPackages: builder.query<ApiResponse<CreditPackage[]>, void>({
      query: () => API_ENDPOINTS.SETTINGS.CREDIT_PACKAGES,
    }),
    getLegalPage: builder.query<ApiResponse<LegalPage>, string>({
      query: (slug) => API_ENDPOINTS.SETTINGS.LEGAL_PAGE(slug),
    }),
    getSocialLinks: builder.query<ApiResponse<{ platform: string; url: string }[]>, void>({
      query: () => API_ENDPOINTS.SETTINGS.SOCIAL_LINKS,
    }),
    sendSupportEmail: builder.mutation<ApiResponse<null>, { subject: string; message: string }>({
      query: (body) => ({
        url: API_ENDPOINTS.SETTINGS.SUPPORT_SEND,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetCreditConfigQuery,
  useGetCreditPackagesQuery,
  useGetLegalPageQuery,
  useGetSocialLinksQuery,
  useSendSupportEmailMutation,
} = settingsApi;
